export default __webpack_public_path__ + "static/eucerin-logo-1be256d31dc00713272d72e031aff693.png";